export function downloadReport({ filePath, fileName }){
  const downloadLink = document.createElement("a");
  document.body.appendChild(downloadLink);
  downloadLink.style = "display: none";
  downloadLink.href = filePath;
  downloadLink.download = fileName;
  downloadLink.click();
  document.body.removeChild(downloadLink);
}